// 서버 검사(istat_back/file/constants.py)가 최종 기준이고, 여기는 요청 전에 안내하려는 사본이다.
// 두 값이 어긋나면 안내와 실제 거절이 달라지므로 uploadLimits.test.ts가 서버 값과 대조한다.
export const MAX_IMPORT_FILE_BYTES = 10_000_000
export const MAX_IMPORT_FILE_SIZE_LABEL = `${MAX_IMPORT_FILE_BYTES / 1_000_000}MB`
